/**
 * waits an amount of time within an async method.
 **/
export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
